import React from 'react';
import { Table, Button, Tooltip, Popconfirm, message } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import moment from 'moment';

import api from '../../../api';
import './list.css';

function List({ interestedCustomers, setInterestedCustomers, selectInterestedCustomer, loadData }) {

    async function deleteInterestedCustomer(id) {
        try {
            await api.delete(`/interested-customers/${id}`);
            message.success('Cliente interessado removido com sucesso!');
            loadData();
        } catch (error) {
            console.error('Erro ao remover:', error);
            message.error('Erro ao remover cliente interessado');
        }
    }

    function formatPriority(priority) {
        const priorities = {
            high: { label: 'Alta', class: 'high' },
            medium: { label: 'Média', class: 'medium' },
            low: { label: 'Baixa', class: 'low' }
        };
        const p = priorities[priority] || priorities.medium;
        return <span className={`priority-tag ${p.class}`}>{p.label}</span>;
    }

    function formatProposal(hasProposal) {
        return hasProposal 
            ? <span className="proposal-tag yes">Sim</span>
            : <span className="proposal-tag no">Não</span>;
    }

    function getLastStatus(statusHistory) {
        if (!statusHistory || statusHistory.length === 0) {
            return <span className="status-message" style={{ color: '#999' }}>-</span>;
        }

        const lastStatus = statusHistory[statusHistory.length - 1];
        return (
            <div className="status-cell">
                <Tooltip title={lastStatus.message}>
                    <div className="status-message">{lastStatus.message}</div>
                </Tooltip>
                <div className="status-info">
                    {lastStatus.user?.name} - {moment(lastStatus.createdAt).format('DD/MM/YY HH:mm')}
                </div>
            </div>
        );
    }

    const columns = [
        {
            title: 'Vendedor',
            dataIndex: 'seller',
            key: 'seller',
            width: 120,
            render: (seller) => (
                <span className="seller-cell">{seller?.name || '-'}</span>
            )
        },
        {
            title: 'Empresa',
            dataIndex: 'company',
            key: 'company',
            width: 250,
            render: (company) => (
                <Tooltip title={company}>
                    <span className="company-cell">{company}</span>
                </Tooltip>
            )
        },
        {
            title: 'Dia',
            dataIndex: 'weekDay',
            key: 'weekDay',
            width: 100,
            render: (weekDay) => weekDay || '-'
        },
        {
            title: 'Data Interesse',
            dataIndex: 'interestDate',
            key: 'interestDate',
            width: 110,
            render: (date) => (
                <span className="date-cell">
                    {date ? moment(date).format('DD/MM/YYYY') : '-'}
                </span>
            )
        },
        {
            title: 'Prioridade',
            dataIndex: 'priority',
            key: 'priority',
            width: 100,
            render: (priority) => formatPriority(priority)
        },
        {
            title: 'Proposta',
            dataIndex: 'hasProposal',
            key: 'hasProposal',
            width: 90,
            render: (hasProposal) => formatProposal(hasProposal)
        },
        {
            title: 'Origem',
            dataIndex: 'originListing',
            key: 'originListing',
            width: 100,
            render: (origin) => origin ? (
                <span className="origin-cell">{origin}</span>
            ) : '-'
        },
        {
            title: 'Vender',
            dataIndex: 'sellTo',
            key: 'sellTo',
            width: 100,
            render: (sellTo) => sellTo ? (
                <span className="sell-to-cell">{sellTo}</span>
            ) : '-'
        },
        {
            title: 'Valor',
            dataIndex: 'value',
            key: 'value',
            width: 120,
            render: (value) => value ? (
                <span className="value-cell">{value}</span>
            ) : '-'
        },
        {
            title: 'Último Status',
            dataIndex: 'statusHistory',
            key: 'statusHistory',
            width: 250,
            render: (statusHistory) => getLastStatus(statusHistory)
        },
        {
            title: 'Ações',
            key: 'actions',
            width: 100,
            fixed: 'right',
            render: (_, record) => (
                <div className="action-buttons">
                    <Tooltip title="Editar">
                        <Button
                            type="primary"
                            size="small"
                            icon={<EditOutlined />}
                            onClick={() => selectInterestedCustomer(record._id)}
                        />
                    </Tooltip>
                    <Popconfirm
                        title="Tem certeza que deseja excluir?"
                        onConfirm={() => deleteInterestedCustomer(record._id)}
                        okText="Sim"
                        cancelText="Não"
                    >
                        <Tooltip title="Excluir">
                            <Button
                                danger
                                size="small"
                                icon={<DeleteOutlined />}
                            />
                        </Tooltip>
                    </Popconfirm>
                </div>
            )
        }
    ];

    return (
        <div className="interested-customers-table-wrap">
            <Table
                className="interested-customers-table"
                columns={columns}
                dataSource={interestedCustomers}
                rowKey="_id"
                pagination={false}
                scroll={{ x: 1400 }}
                size="small"
            />
        </div>
    );
}

export default List;
